import React from 'react';
import { createComponent, PropTypes } from "../../../../wayin-react";
import { sizes } from "../../../../enums";
import Panel from "../../panel";
import DefaultPreviewTemplate from "./preview-templates/default";
import FacebookSharePreviewTemplate from "./preview-templates/facebook";
import GoogleSharePreviewTemplate from "./preview-templates/google";
import TwitterSharePreviewTemplate from "./preview-templates/twitter";
import PinterestSharePreviewTemplate from "./preview-templates/pinterest";
var SharingPreview = createComponent({
  displayName: 'SharingPreview',
  propTypes: {
    network: PropTypes.string,
    previewData: PropTypes.shape({
      name: PropTypes.string,
      title: PropTypes.string,
      byline: PropTypes.string,
      message: PropTypes.string,
      picture: PropTypes.string
    }),
    messagePlaceholder: PropTypes.string
  },
  defaultProps: {
    network: 'default',
    previewData: {
      name: undefined,
      title: undefined,
      byline: undefined,
      message: undefined,
      picture: undefined
    },
    messagePlaceholder: '{User defined message}'
  },
  lifecycles: {
    shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
      return this.props.previewData !== nextProps.previewData;
    }
  },
  render: function render(p) {
    return /*#__PURE__*/React.createElement(Panel, {
      hasBorder: false,
      padding: {
        horizontal: null,
        vertical: sizes.X1
      }
    }, p.network === 'default' ? /*#__PURE__*/React.createElement(DefaultPreviewTemplate, {
      network: p.network,
      name: p.name,
      previewData: p.previewData
    }) : p.network === 'facebook' ? /*#__PURE__*/React.createElement(FacebookSharePreviewTemplate, {
      network: p.network,
      name: p.name,
      previewData: p.previewData,
      messagePlaceholder: p.messagePlaceholder
    }) : p.network === 'google' ? /*#__PURE__*/React.createElement(GoogleSharePreviewTemplate, {
      network: p.network,
      name: p.name,
      previewData: p.previewData,
      messagePlaceholder: p.messagePlaceholder
    }) : p.network === 'twitter' ? /*#__PURE__*/React.createElement(TwitterSharePreviewTemplate, {
      network: p.network,
      name: p.name,
      previewData: p.previewData
    }) : p.network === 'pinterest' ? /*#__PURE__*/React.createElement(PinterestSharePreviewTemplate, {
      network: p.network,
      name: p.name,
      previewData: p.previewData
    }) : null);
  }
});
export default SharingPreview;
//# sourceMappingURL=sharing-preview.js.map